class LegendBarController {

  constructor() {
    this.name = 'legendBar';
  }
}

export default LegendBarController;



// WEBPACK FOOTER //
// ./app/common/legendBar/legendBar.controller.js